// Composites a brand's REAL watermark image (logo + wordmark pill) onto a media
// preview at the brand's saved position / scale / opacity — so the on-screen
// look matches what actually gets stamped onto the rendered post. Positioning
// mirrors Settings' wmBoxStyle exactly for a consistent live preview.
export const WatermarkOverlay = ({ wmUrl, position = "bottom-right", scale = 300, opacity = 0.6 }) => {
  if (!wmUrl) return null;
  const pos = position || "bottom-right";
  const style = {
    position: "absolute",
    width: `${(Math.max(120, Math.min(scale || 300, 560)) / 1080) * 100}%`,
    opacity: opacity ?? 0.6,
  };
  const side = pos.startsWith("top") ? "5.5%" : "11%";
  if (pos.startsWith("bottom")) style.bottom = pos === "bottom-center" ? "12.5%" : "13.5%";
  else style.top = "6.25%";
  if (pos.endsWith("right")) style.right = side;
  else if (pos.endsWith("left")) style.left = side;
  else { style.left = "50%"; style.transform = "translateX(-50%)"; }

  return (
    <div className="absolute inset-0 pointer-events-none z-[6]" data-testid="watermark-overlay">
      <img src={wmUrl} alt="" style={style} onError={(e) => { e.target.style.display = "none"; }} />
    </div>
  );
};

export default WatermarkOverlay;
